<template>
  <svg :width="width" :height="height" :class="className" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 39H54V43H9V39Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M89 20C90.6569 20 92 21.3431 92 23V57.0152L92 57.0313C91.9911 58.6881 90.6407 60.0241 88.9839 60.0152L84.25 59.9898V67.2635C84.25 67.4763 84.1821 67.6836 84.0562 67.8552C83.7294 68.3004 83.1035 68.3965 82.6583 68.0697L71.7137 60.0367H65.0625C64.5102 60.0367 64.0625 60.4844 64.0625 61.0367C64.0625 61.589 64.5102 62.0367 65.0625 62.0367H71.0585L81.4749 69.682C82.8106 70.6624 84.6881 70.3743 85.6685 69.0386C86.0463 68.5239 86.25 67.902 86.25 67.2635V62.0006L88.9732 62.0152C91.7346 62.03 93.9851 59.8034 93.9999 57.042L94 57.0152V23C94 20.2386 91.7614 18 89 18H35C32.2386 18 30 20.2386 30 23C30 23.5523 30.4477 24 31 24C31.5523 24 32 23.5523 32 23C32 21.3431 33.3431 20 35 20H89Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M60 35H84.4878V39H60V35Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M62 43H84.4878V45H62V43Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.1849 67.0624H58C59.1046 67.0624 60 66.1669 60 65.0624V30C60 28.8954 59.1046 28 58 28H6C4.89543 28 4 28.8954 4 30V65.0624C4 66.1669 4.89543 67.0624 6 67.0624H11.9061L11.9061 75.1121L22.1849 67.0624ZM22.8749 69.0624H58C60.2091 69.0624 62 67.2715 62 65.0624V30C62 27.7909 60.2091 26 58 26H6C3.79086 26 2 27.7909 2 30V65.0624C2 67.2715 3.79086 69.0624 6 69.0624H9.90613V75.112C9.90613 76.7794 11.8265 77.7147 13.1393 76.6867L22.8749 69.0624Z"
      fill="#05070F"
    />
    <path d="M9 47H47V49H9V47Z" fill="#FF0064" />
    <path d="M9 51H41V53H9V51Z" fill="#FF0064" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MessagingIllustration',
  props: {
    width: {
      type: Number,
      default: 96,
    },
    height: {
      type: Number,
      default: 96,
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>
